import type { ReactNode } from "react";
import { Link } from "react-router";
import { PageContainer } from "@/app/layouts/PageContainer";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

export interface DetailTab { id: string; label: string; content: ReactNode; }
export interface DetailPageProps {
  title: ReactNode;
  primaryAction?: ReactNode;
  tabs: readonly DetailTab[];
  defaultTab?: string;
  backTo?: string;
  children?: ReactNode;
}

export function DetailPage({ title, primaryAction, tabs, defaultTab, backTo, children }: DetailPageProps) {
  return (
    <PageContainer>
      {backTo && (
        <Link to={backTo} className="mb-2 inline-block text-sm text-muted-foreground hover:underline">← Back</Link>
      )}
      <div className="mb-4 flex items-center justify-between">
        <h1 className="text-2xl font-semibold">{title}</h1>
        {primaryAction}
      </div>
      <Tabs defaultValue={defaultTab ?? tabs[0]?.id}>
        <TabsList>
          {tabs.map((t) => (<TabsTrigger key={t.id} value={t.id}>{t.label}</TabsTrigger>))}
        </TabsList>
        {tabs.map((t) => (<TabsContent key={t.id} value={t.id}>{t.content}</TabsContent>))}
      </Tabs>
      {children}
    </PageContainer>
  );
}
